<template>
	<div class="content-wrap content-wrap--notfall content-wrap--bigger">
		<kapp-header id="mainHeader"></kapp-header>
		<master-block v-for="data in content" :data="data" :key="data.title"></master-block>
	</div>
</template>

<script>
	import apiCall, {ApiDefaults} from "../utils/api_call";
	import MasterBlock from "../components/blocks/MasterBlock";
	import Header from "../components/layouts/Header";

	export default {
		name: "KappNotfall",
		data() {
			return {
				content : []
			}
		},
		props: [],
		components : {
			'master-block' : MasterBlock,
			'kapp-header' : Header
		},
		methods: {
			fetchData ( ) {

				apiCall( Object.assign({}, ApiDefaults, { params: { id : 16 } } ) )
					.then( ( response ) => {
						if( response.status === 200  ) {
							// console.log( response );
							if( response.data.ttContent )
								this.content = response.data.ttContent.content;
						}
					})
					.catch( ( err ) => {})
			}
		},
		created() {
			this.fetchData();
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/KappNotfall.vue